import * as Highcharts from 'highcharts/highstock';
import { colors } from '@shared/interfaces/paleta-cores';
import { COR_REGIAO_INDIVIDUAL } from '../../../utils';

export const optionsChartClimatologia = (): Highcharts.Options => ({
	chart: {
		type: 'column',
		backgroundColor: 'transparent',
	},
	title: {
		text: 'Climatologia',
		align: 'center',
		widthAdjust: -55,
	},
	subtitle: {
		text: '',
		align: 'left',
	},
	xAxis: {
		categories: [],
		title: {
			text: 'Meses',
		},
	},
	yAxis: {
		min: 0,
		title: {
			text: 'Climatologia (mm)',
		},
	},
	tooltip: {
		valueSuffix: ' mm',
	},
	plotOptions: {
		column: {
			borderWidth: 0,
		},
	},
	colors: colors,
	series: [],
});
export const relatorioClimatologia: Array<
	Partial<Highcharts.SeriesOptionsType> & Record<string, any>
> = [
	{
		name: 'Climatologia',
		type: 'column',
		color: COR_REGIAO_INDIVIDUAL,
		data: [],
		pointPadding: 0.2,
	},
];
